/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_in_range.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns `true` if at least one value of `field` is within the range `[lower, upper]`, using the natural order of the type. A null or empty field returns `false`, as does a null bound. Both bounds are inclusive by default; set `include_lower` or `include_upper` to `false` in the optional `options` map to make either bound exclusive, covering all four interval forms. Works on any ordered type: numbers, dates, IPs, versions, and strings (compared by their UTF-8 bytes).',
  examples: [
    'ROW values = [1, 5, 10]\n| EVAL in_range = mv_in_range(values, 4, 6)',
    'ROW values = [0, 100]\n| EVAL in_range = mv_in_range(values, 40, 60)',
    'ROW words = ["apple", "cherry"]\n| EVAL in_range = mv_in_range(words, "banana", "date")',
    'ROW values = [3, 6]\n| EVAL in_range = mv_in_range(values, 4, 6, {"include_upper": false})',
    'ROW values = [4, 6]\n| EVAL in_range = mv_in_range(values, 4, 6, {"include_lower": false, "include_upper": false})',
  ],
  params: {
    field: 'Multivalue expression to test. If null or empty, the function returns `false`.',
    lower: 'Lower bound, of the same type as `field`. If null or multivalued, the function returns `false`.',
    upper: 'Upper bound, of the same type as `field`. If null or multivalued, the function returns `false`.',
    options: '(Optional) Range boundary options.',
  },
};

export default docs;
